import { isEmpty, isNil } from 'lodash';
import React, { useContext, useMemo } from 'react';
import EntityForm from '../../../../../common/components/containers/EntityForm';
import EntityFormFieldSet from '../../../../../common/components/containers/EntityForm/EntityFormFieldSet';
import StatusField from '../../../../../common/components/containers/EntityForm/fields/StatusField';
import EntityNameField from '../../../../../common/components/containers/EntityForm/fields/EntityNameField';
import useTranslation from '../../../../../common/components/utils/Translations/useTranslation';
import { Active } from '../../../../../model/Statuses';
import { AssetCategoryTreeContext } from './AssetCategoryTree';
const AssetFolderForm = ({ node = { id: null }, onCancel, onSubmit, parentNode, }) => {
    const { t } = useTranslation();
    const { assetGroupId } = useContext(AssetCategoryTreeContext);
    const isNew = isNil(node === null || node === void 0 ? void 0 : node.id);
    const initialValues = useMemo(() => {
        const entity = {
            status: Active.value,
            assetGroupId,
        };
        if (!isEmpty(parentNode)) {
            entity.parentId = parentNode === null || parentNode === void 0 ? void 0 : parentNode.id;
        }
        return isNew ? entity : node;
    }, [isNew, node, assetGroupId, parentNode]);
    return (<>
      <EntityForm entity={initialValues} entityName={`AssetFolderForm-${isNew ? 'new' : node.id}`} onCancel={onCancel} onSubmit={onSubmit}>
        <EntityFormFieldSet>
          <EntityNameField columns={3} label={t('Asset Folder Name')}/>
          <StatusField columns={3} isNew={isNew}/>
        </EntityFormFieldSet>
      </EntityForm>
    </>);
};
export default AssetFolderForm;
